import Vue from "vue";
import Router from "vue-router";
//------------------------------
import home from "./home/router"
import message from "./message/router"
import selectUnit from "./selectUnit/router"
import linkage from "./linkage/router"
import setting from "./setting/router"
import inspect from "./inspect/router"
import prospect from "./prospect/router"
import account from "./account/router"
import device from "./device/router"
import player from "./player/router"
import alarm from "./alarm/router"
import safety from "./safety/router"
import order from "./order/router"
import danger from "./danger/router"
import mime from "./mime/router"
import pamera from "./pamera/router"
import pay from "./pay/router"
import snapshot from "./snapshot/router"
Vue.use(Router);

export default new Router({
    routes: [
        ...home,// 首页
        ...message,// 消息
        ...selectUnit,// 切换单位
        ...linkage,// 智能场景
        ...setting,// 系统设置
        ...inspect,// 巡检
        ...prospect,// 勘察
        ...account,// 账号
        ...device,// 设备
        ...player,// 播放器
        ...alarm,// 告警
        ...safety,// 安全打卡
        ...order,// 工单
        ...danger,// 隐患排查
        ...pay,// 服务费
        ...mime,// 个人中心
        ...pamera,// 外部跳转
        ...snapshot,//随手拍
    ],mode:'hash'
});
